import {
  SubmissionJob,
  SubmissionJobs,
} from "~/classes/models/submission-job/submission-job.model";

export const useSubmissionJobs = defineStore("submission-jobs", () => {
  const submissionJobs = ref<SubmissionJobs>([]);

  const addSubmissionJob = async (submissionJob: SubmissionJob) => {
    submissionJobs.value.push(submissionJob);

    await nextTick();

    submissionJob.sheetController.open();
  };

  const removeSubmissionJob = (submissionJob: SubmissionJob) => {
    submissionJobs.value = submissionJobs.value.filter(
      (job) => job.id != submissionJob.id
    );
  };

  return {
    submissionJobs,
    addSubmissionJob,
    removeSubmissionJob,
  };
});
